import { defineComponent as _defineComponent } from 'vue'

import type { MetaInfo } from 'vue-meta';
import { makeRssMetaInfo } from '@/routing/editorial';
import { computed } from 'vue';
import { ProfileType } from '@/@types/graphql-types';

const __default__ = {
	name: 'EditorialArticle',
	metaInfo(): MetaInfo {
		return makeRssMetaInfo();
	},
};

import { useAppStore, useLanguageStore } from '@/helpers/composables/useStores';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useArticle } from '@/helpers/composables/useArticle';
import { BuyboxParam, OfferLocation } from '@/helpers/offer-helper';

import { clickArticleLink } from '@/pages/editorial/tracking';

import AuthorBox from '@/components/editorial/AuthorBox.vue';
import ListArticle from '@/components/editorial/ListArticle.vue';
import NewsArticle from '@/components/editorial/NewsArticle.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { SnowplowPackageContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { country } = useLanguageStore();
const { article, author, mainObject, listEvents, publishDate, updatedDate, backdrop, isUpdated, isLoading } =
	useArticle();

const { xServeTrack } = useAppStore();

const offerClickoutUrl = computed(() => {
	if (mainObject.value?.__typename === 'GenericTitleList' || !mainObject.value?.watchNowOffer) return null;

	const offer = mainObject.value.watchNowOffer;

	return new ClickoutUrl(offer)
		.addContexts(new SnowplowTitleContextGraphql(mainObject.value.objectId, mainObject.value.objectType))
		.addContexts(new SnowplowPackageContext(offer.package.packageId, offer.package.technicalName))
		.setForTracking('offerLocation', OfferLocation.PROMOTED_BUYBOX)
		.set('uct_country', country.value)
		.set('uct_buybox', BuyboxParam.Normal)
		.updateContext('TitleContextGraphql', 'offerEntityId', mainObject.value.id)
		.setCanary(xServeTrack.value);
});

/* TRACKING */
function trackContentClick(e: Event) {
	const target = e.target as HTMLElement;
	if (target.nodeName !== 'A') return;

	const property = (target as HTMLAnchorElement).href;

	clickArticleLink({
		category: 'userinteraction',
		action: 'content_clicked',
		label: property.includes('justwatch.com') ? 'internal' : 'external',
		property,
	});
}

return { __sfc: true,country, article, author, mainObject, listEvents, publishDate, updatedDate, backdrop, isUpdated, isLoading, xServeTrack, offerClickoutUrl, trackContentClick, ProfileType, AuthorBox, ListArticle, NewsArticle, PictureComp, ProviderIcon }
}

})